export const ACTIONS_DOMAIN = 'app/modules/Contents/ACTIONS_DOMAIN';
export const REQUEST_ACTIONS = 'app/modules/Contents/REQUEST_ACTIONS';
export const REQUEST_ACTION = 'app/modules/Contents/REQUEST_ACTION';
export const SET_SCROLL_POSITION = 'app/modules/Contents/SET_SCROLL_POSITION';
